/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { greenApiWebhookInstanceDataSchema } from "./greenApiWebhookInstanceDataSchema.ts";
import { greenApiWebhookMessageDataSchema } from "./greenApiWebhookMessageDataSchema.ts";
import { greenApiWebhookSenderDataSchema } from "./greenApiWebhookSenderDataSchema.ts";

export const greenApiWebhookSchema = z.object({
	instanceData: greenApiWebhookInstanceDataSchema,
	senderData: greenApiWebhookSenderDataSchema,
	messageData: greenApiWebhookMessageDataSchema,
});
